/* global define */

/*! 
* bearcubs.js
* (c) Gilles Rivière
* Released under the MIT license
*/

const version = "bearcubs.js v1.0.0"

// eventEmitter
const eventEmitter = function(eventsArray) {
    let eventsList = {};
    let eventsListBuilder = function() {
        if (!eventsArray) {
            eventsArray = [];
        }
        for (let i=0; i < eventsArray.length; i++) {
            eventsList[eventsArray[i]] = [];
        }
    };
    eventsListBuilder();
    eventsListBuilder = null;
    return {
        emit: function(onName, value) {
            if (eventsList[onName] && eventsList[onName].length) {
                for (let i = 0; i < eventsList[onName].length; i++) {
                    eventsList[onName][i](value);
                }
            }
        },
        on: function(onName, onCB) {
            if (!onName || !onCB || typeof onName !== "string" || typeof onCB !== "function") {
                throw Error("db.on('onName', onCB())");
            } else {
                if (eventsList[onName]) {
                    eventsList[onName].push(onCB);
                } else {
                    console.warn("eventEmitter.on('" + onName + "') not allowed.");
                }
            }
        },
        add: function(eventName) {
            if (!eventsList[eventName]) {
                eventsList[eventName] = [];
            } else {
                return console.warn("eventEmitter.add('" + eventName + "') -> event already exist.");
            }
        },
        remove: function(eventName) {
            if (eventsList[eventName]) {
                eventsList[eventName] = null;
                delete eventsList[eventName];
            } else {
                return console.warn("eventEmitter.remove('" + eventName + "') -> not found.");
            }
        },
        getEventsList: function() {
            return eventsList;
        },
        destroy: function() {
            for (let i in eventsList) {
                eventsList[i] = [];
            }
            this.emit = null;
            this.on = null;
            this.add = null;
            this.remove = null;
            this.getEventsList = null;
            this.destroy = null;
        }
    };
};

    // getCookieOrQuery
function getCookieOrQuery(name, cookieOrQuery, url){
    if (!name) {
        throw new Error("getCookieOrQuery('name', 'selector');");
    }
    let result = {};
    let rawResult = null;
    if (!cookieOrQuery || cookieOrQuery === "cookie") {
        rawResult = document.cookie;
        rawResult = rawResult.replace(/\s/g, "");
        rawResult = rawResult.split(';');
    } else {
        if (url) {
            rawResult = url;
        } else {
            rawResult = decodeURIComponent(window.location);
        }
        url = null;
        rawResult = rawResult.replace(/\s/g, "");
        rawResult = rawResult.replace(/\//g, ""); //<- new -> to remove "/"
        rawResult = rawResult.split('?');
        if (rawResult.length > 1) {
            rawResult = rawResult[1].split('&');
        } else {
            return null;
        }
    }
    for (let i=0; i<rawResult.length; i++) {
        let iResult = rawResult[i].split("=");
        if (iResult && iResult.length > 1) {
            result[iResult[0]] = iResult[1].split('#')[0];
            if (iResult[1] === 'false') {
                result[iResult[0]] = false;
            } else if (iResult[1] === 'true') {
                result[iResult[0]] = true;
            }
        }
        iResult = null;
    }
    if (name !== "*all") {
        if (result[name] !== undefined && result[name] !== null) {
            return result[name];
        } else {
            return null;
        }
    } else {
        if (Object.keys(result).length) {
            return result;
        } else {
            return null;
        }
    }
}

// getCookie
const getCookie = function(name) {
    return getCookieOrQuery(name, null, null);
};

// getQuery
const getQuery = function(name, url) {
    if (!url) {
        url = null;
    }
    return getCookieOrQuery(name, 'param', url);
};

// export
export { version, eventEmitter, getCookie, getQuery }; //<- ES6 Modules
//module.exports = { version, eventEmitter }; //<- CommonJS

// import examples:
/*
    // ES6 Modules
//import { version } from './vendors/bearcubs';
//console.log(version);
import * as Bear from './vendors/bearcubs';
console.log(Bear.version);

    // CommonJS
//const { version } = require('./vendors/bearcubs');
const Bear = require('./vendors/bearcubs');
*/